@if (displayCategoryHTML) {
  <div>
    <div class="d-flex justify-content-end w-100 mb-3">
      <button class="mwp-button" (click)="continueToForm()">
        <mwp-text-translate text="Continue" jsonKey="continue" />
      </button>
    </div>
    <div class="w-100">
      <div [innerHTML]="enrollmentCategoryOptions.categoryHTML | pipeSafeHTML"></div>
    </div>
  </div>
}
@if (!displayCategoryHTML) {
  <div>
    <div class="content-container mb-3">
      <div class="title pb-0 d-inline-flex justify-content-between w-100">
        @if (isEnrollmentMode) {
          <mwp-text-translate text="Available Benefits" jsonKey="availableBenefits" />
        } @else {
          <mwp-text-translate text="Benefit Previews" jsonKey="benefitPreviews" />
        }
        @if (displayResourcesButton) {
          <button class="mwp-button mt-auto" (click)="resourcesSelected()">
            <mwp-text-translate text="Resource Links" jsonKey="resourceLinks" />
          </button>
        }
      </div>
      <div class="content">
        <div>
          <mwp-table [tableColumns]="availableBenefitsColumns" [dataSource]="availableBenefitsMatTableData" [isCustomColumnNameMatchValueName]="true" />
        </div>
      </div>
      @if (availableBenefitsButtons) {
        <div class="footer d-inline-flex justify-content-end w-100">
          @for (availableBenefitsButton of availableBenefitsButtons; track availableBenefitsButton) {
            <div class="ps-3">
              <button [class]="availableBenefitsButton.cssStyle" class="px-3" (click)="selectWizard(availableBenefitsButton)">
                <mwp-text-translate [text]="availableBenefitsButton.name" [jsonKey]="availableBenefitsButton.name" />
              </button>
            </div>
          }
        </div>
      }
    </div>
    <div class="content-container mb-3">
      <div class="title pb-0">
        <mwp-text-translate text="Current Benefits and Requests" jsonKey="currentBenefitsAndRequests" />
      </div>
      <div class="content p-0">
        <mwp-card-benefit-summary [benefitSummaryList]="benefitSummaryList" [isNoBorder]="true" [displayBenefitColumn]="true" [displayProcessColumn]="true" [enableToggle]="true" [showSummary]="false" />
      </div>
      @if (currentBenefitButtons) {
        <div class="footer d-inline-flex justify-content-end w-100">
          @for (currentBenefitButton of currentBenefitButtons; track currentBenefitButton) {
            <div class="ps-3">
              <button [class]="currentBenefitButton.cssStyle" class="px-3" (click)="selectWizard(currentBenefitButton)">
                <mwp-text-translate [text]="currentBenefitButton.name" [jsonKey]="currentBenefitButton.name" />
              </button>
            </div>
          }
        </div>
      }
    </div>
    @if (benefitSummaryList.summaryBenefitCards.length > 0) {
      <div class="content-container table-comp mb-3">
        <div class="title">
          <mwp-text-translate text="Current Costs" jsonKey="currentCosts" />
        </div>
        <div class="content p-0">
          <mwp-card-benefit-summary [benefitSummaryList]="benefitSummaryList" [isNoBorder]="true" [displayBenefitColumn]="true" [displayProcessColumn]="true" [enableToggle]="true" [showSummaryGridOnly]="true" />
        </div>
      </div>
    }
    <!-- <div class="w-100 d-flex justify-content-end">
      <button class="mwp-button" (click)="nextCategorySelected()">
        <mwp-text-translate text="Next Category" jsonKey="nextCategory" />
      </button>
    </div> -->
  </div>
}